<template>
    <div>
        <page-title>{{ $t('menu.custom_update') }}</page-title>
        <show-table is-update></show-table>
    </div>
</template>

<script>
import ShowTable from '@/components/pages/customExport/ShowTable.vue'
import PageTitle from '@/components/layout/components/pageTitle.vue'

export default {
    components: { PageTitle, ShowTable },
}
</script>
